import React from 'react';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ProblemDetails } from '../../api/web-api-client';
import ErrorDisplay from './ErrorDisplay';
import { HttpStatusCode } from '../../types';

export interface IErrorBoundaryProps {
    appInsights: ReactPlugin;
    // onError: React.ComponentType<any>;
    children: React.ReactElement | React.ReactNode;
}
export interface IErrorBoundaryState {
    hasError: boolean;
    details: ProblemDetails | undefined;
}
class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false, details: undefined };
    }

    static getDerivedStateFromError(error: any) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({ hasError: true, details: error as ProblemDetails });
        const { appInsights } = this.props;
        appInsights.getAppInsights().trackException({
            error,
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: { ...errorInfo },
        });
    }

    render() {
        const { hasError, details } = this.state;
        const { children } = this.props;
        if (hasError && details) {
            const statusCode = details.status ?? 0;
            return <ErrorDisplay status={statusCode} />;
        }

        if (hasError) {
            return (
                <ErrorDisplay status={HttpStatusCode.InternalServerError} />
            );
            // return typeof onError === 'function'
            //     ? onError()
            //     : React.createElement(onError);
        }

        return children;
    }
}

export default ErrorBoundary;
